/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import { Native } from '@zz-biz/adapter'

Vue.use(Router)
// Vue.use(Dialog);
/**
 * 路由meta参数含义
 * @param {string} title 页面标题，默认空字符
 * @param {boolean} login 页面是否自动登录，默认false
 * @param {boolean} prompt 是否全局弹窗，默认false
 * @param {boolean} protocol 是否请求协议标题，默认false，使用：this.$protocolTitle
 * @param {boolean} keepAlive 是否保存页面状态, 默认false
 * @param {boolean} floatBtn 是否需要联系运营弹窗
 *                           默认{staff: false, share: false, tel: false, assisstant: 智能助手}，staff: 专属运营按钮，share: 分享按钮，tel: 电话按钮, assisstant: 智能助手
 *                           也可通过地址栏参数控制，float_btn_staff=1, float_btn_share=1, float_btn_tel=1
 * @param {object|boolean} intercept 离开页面拦截弹窗功能 { title: '' // 标题, message: '' // 内容， exclude: ['path'] // 排除的页面 }
 */
const router = new Router({
  routes: [
    // {
    //   path: '/browseAndEarn/home',
    //   name: 'browseAndEarnHome',
    //   meta: {
    //     title: '签到领红包',
    //   },
    //   component: () => import('../views/browseAndEarn/index/index.vue'),
    // },
    // // 1.0新版提现页
    // {
    //   path: '/earn/withdraw',
    //   name: 'newEarnWithdraw',
    //   meta: {
    //     title: '提现专区',
    //   },
    //   component: () => import('../views/browseAndEarn/withdraw/index.vue'),
    // },
    // // 看视频领曝光
    // {
    //   path: '/exposure/home',
    //   name: 'exposureHome',
    //   meta: {
    //     title: '看视频领曝光',
    //   },
    //   component: () => import('../views/exposure/index/index.vue'),
    // },
    // // 曝光记录列表
    // {
    //   path: '/exposure/list',
    //   name: 'exposureList',
    //   meta: {
    //     title: '曝光数记录',
    //   },
    //   component: () => import('../views/exposure/list/index.vue'),
    // },
    {
      path: '*', //404，应置于最后，前面没有任何匹配时才让此项生效
      name: 'notFound',
      meta: {
        title: '页面不存在',
      },
      component: () => import('../views/httpStatus/404.vue'),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (from.name === 'basicparams' && to.name === 'post') {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach((to, from, next) => {
  const { title } = to.meta
  // 如果设置标题，拦截后设置标题
  document.title = title
  console.log(title);
  Native.setTitle({
    title,
  })
  next()
})
export default router
